import {TimeSpan} from "@sparkware/app-utils";
import {delay} from "../../../utils/delay";
import {InGameChallengesController_GetTicketPrizesResponse} from "../api/api.service";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IInGameTicketPrize} from "./prize/abstract/in-game-ticket-prize-types";

type TicketPrizesResponseData = InGameChallengesController_GetTicketPrizesResponse["data"];

interface ITicketPrizesResponseData extends TicketPrizesResponseData {
    prizes: IInGameTicketPrize[]
}

export class InGamePromotionPrizes {
    private prizesPromise: Promise<ITicketPrizesResponseData> | null = null;

    public constructor(public readonly promotionId: number, private services: IServiceFactoryExtended) {}

    async getPrizes() {
        if (!this.prizesPromise) {
            this.prizesPromise = this.fetchPrizes();
        }
        return this.prizesPromise;
    }

    public resetGetPrizesFailedPromise() {
        if (this.prizesPromise) {
            return this.prizesPromise.catch(() => {
                this.prizesPromise = null;
            }).then(() => {
                return this.getPrizes();
            });
        } else {
            return this.getPrizes();
        }
    }

    private async fetchPrizes(retry: boolean = false, retryInterval: TimeSpan = TimeSpan.fromMilliseconds(1000)): Promise<ITicketPrizesResponseData> {
        try {
            let response = await this.services.api.inGameChallengesController.getTicketPrizes({promotionId: this.promotionId});
            if (response.hasError) {
                const errorMsg = `InGame Challenge: ticket prizes fetch errored: ` + JSON.stringify({
                    errorCode: response.errorCode,
                    errorDescription: response.errorDescription,
                    errorDetails: response.errorDetails
                });
                this.services.logger.debug(errorMsg);
                throw new Error(errorMsg);
            } else {
                const responseData = {
                    ...response.data,
                    prizes: response.data.prizes.map((p) => this.services.inGameTicket.ticketPrizeFactory.createInGameTicketPrize(p))
                }
                return responseData;
            }
        } catch (e) {
            if (retry) {
                await delay(retryInterval);
                return await this.fetchPrizes();
            } else {
                throw e;
            }
        }
    }

}
